<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    width="900"
    @keydown.esc="closeButtonClickEvent"
  >
    <validation-observer ref="finalDisposalReportValidator">
      <v-card flat>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            最終処分終了報告（個別登録）
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifests"
          style="max-height: 70vh;overflow-y: scroll"
          class="card-layer"
        >
          <v-card
            v-for="(manifest, index) in manifests"
            :key="manifest.id"
            flat
          >
            <v-card-text>
              <manifest-detail :manifest="manifest" :caller-type="'final_disposal_report'" />
              <br />
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="最終処分終了日・最終処分事業場"
                rules="required"
              >
              <v-input
                v-model="manifest.manifest_final_disposals"
                :error-messages="errors"
                dense
                label="最終処分終了日・最終処分事業場"
                outlined
                readonly
              />
                <final-disposal-report-form
                  :manifest="manifest"
                  :manifest-final-disposals="manifest.manifest_final_disposals"
                  :final-disposal-sites="finalDisposalSites"
                  @addButtonCallback="addFinalDisposals"
                  @removeButtonCallback="removeFinalDisposal"
                />
              </validation-provider>
            </v-card-text>
            <v-divider v-if="index < manifests.length - 1" />
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="manifests===null"
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>

import manifestDetail from './contents/_ManifestDetail'
import finalDisposalReportForm from './forms/_FinalDisposalReportForm'
import { mapActions } from 'vuex'

export default {
  name: 'FinalDisposalReportDialog',
  components: {
    manifestDetail,
    finalDisposalReportForm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    sortType: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      manifests: null,
      finalDisposalSites: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.manifests = null
      this.scrollToTop()
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverManifestFinalDisposalReport', {
      fetchFinalDisposals: 'show',
      updateFinalDisposals: 'update',
    }),
    ...mapActions('DriverOrderFinalDisposalReport', {
      fetchFinalDisposalsByOrder: 'show',
      updateFinalDisposalsByOrder: 'update',
    }),
    ...mapActions('DriverMasterSearchFinalDisposalSite', {
      fetchFinalDisposalSites: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let self = this
      this.$refs.finalDisposalReportValidator.validate().then((result) => {
        if (result) {
          let params = this.buildParams()

          if (this.type === "Managements") {
            self.updateFinalDisposals({ params: params }).then(() => {
              this.$emit('registerEvent')
            })
          } else {
            params['order_ids'] = this.orderIds
            self.updateFinalDisposalsByOrder({ params: params }).then(() => {
              this.$emit('registerEvent')
            })
          }
        }
      })
    },
    buildParams () {
      const params = []
      this.manifests.forEach((manifest, index) => {
        let param = {}
        param.id = manifest.id
        param.manifest_final_disposals_attributes = []
        for (let manifest_final_disposal of manifest.manifest_final_disposals) {
          if (!manifest_final_disposal._destroy) {
            let final_params = {
              final_disposal_date: manifest_final_disposal.final_disposal_date,
              final_disposal_siteable_id: manifest_final_disposal.final_disposal_site_id,
              final_disposal_siteable_type: 'FinalDisposalSite',
            }
            param.manifest_final_disposals_attributes.push(final_params)
          }
        }
        params.push(param)
      })
      return {
        manifests: params,
        manifest_ids: this.manifestIds,
        type: this.type,
      }
    },
    setVariable () {
      this.fetchFinalDisposalSites().then((content) => {
        this.finalDisposalSites = content.final_disposal_sites
      })

      let params = { manifest_ids: this.manifestIds, sort_type: this.sortType }
      if (this.type === "Managements") {
        this.fetchFinalDisposals({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      } else {
        /** 受注発注の場合はorder単位でのマニフェスト絞込が必要 */
        params["order_ids"] = this.orderIds
        this.fetchFinalDisposalsByOrder({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      }
    },
    /**
     * 最終処分終了報告 追加ボタンコールバック
     */
    addFinalDisposals (manifest_id) {
      let time = new Date().getTime()
      let targetManifest = this.manifests.find(v => v.id === manifest_id)
      targetManifest.manifest_final_disposals.push({
        id: null,
        manifest_id: manifest_id,
        key: time,
        final_disposal_date: null,
        final_disposal_site_id: null,
        _destroy: false,
      })
    },
    /**
     * 最終処分終了報告 削除ボタンコールバック
     */
    removeFinalDisposal (manifest_id, item) {
      let targetManifest = this.manifests.find(v => v.id === manifest_id)
      let finalDisposal = targetManifest.manifest_final_disposals.find(v => v.key === item.key)
      if (finalDisposal) {
        finalDisposal.final_disposal_date = null
        finalDisposal.final_disposal_site_id = null
        finalDisposal._destroy = true
      }
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },

  }
}
</script>
